import CheckIcon from '@mui/icons-material/Check';
import { useTheme } from '@mui/material';

export const Check = () => {
  const theme = useTheme();

  return <CheckIcon sx={{ color: theme.palette.quaternary.main }} />;
};
